import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { AlertError, AlertLoading } from "../../helpers/AlertHelper";
import BarChart from "../../components/charts/BarChart";
import CashFlowsService from "../../services/CashFlowsService";

const CashFlowReport = ({ selectedYear = null }) => {
  const intl = useIntl();
  const [cashFlowData, setCashFlowData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);

  const fetchCashFlowData = async () => {
    try {
      setIsLoaded(false);
      setError(null);

      const filters = {};
      if (selectedYear) filters.selectedYear = selectedYear;

      const cashFlowresponse = await CashFlowsService.getCashFlowsDataset({
        selectedYear,
      });

      const formattedCashFlow = {
        labels: cashFlowresponse.data.labels,
        datasets: [
          {
            label: intl.formatMessage({
              id: "cashFlowAccumulative",
              defaultMessage: "Dinero en Caja (Acumulativo)",
            }),
            data: cashFlowresponse.data.datasets[0].data,
            borderColor: "rgb(53, 162, 235)",
            backgroundColor: "rgba(53, 162, 235, 0.5)",
            yAxisID: "y",
            datalabels: {
              anchor: "end",
              align: "end",
              color: "#333",
              font: {
                weight: "bold",
              },
              formatter: (value) =>
                value.toLocaleString("es-ES", {
                  style: "currency",
                  currency: "EUR",
                }),
            },
          },
        ],
      };

      setCashFlowData(formattedCashFlow);
      setIsLoaded(true);
    } catch (err) {
      setIsLoaded(false);
      setError(err);
    }
  };

  useEffect(() => {
    fetchCashFlowData();
  }, [selectedYear]);

  return (
    <>
      {error && <AlertError error={error} />}
      {!isLoaded && <AlertLoading isLoaded={isLoaded} />}
      {isLoaded && cashFlowData && <BarChart data={cashFlowData} />}
    </>
  );
};

export default CashFlowReport;
